'use strict';

module.exports.AccessManager = require('./accessmanager');